var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFenjie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.59581 3.42265L6.57725 0.873871L14.2677 2.57306L9.14073 5.97144L0.59581 3.42265Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53314 0.399261L15.4099 2.36058L9.21451 6.46719L0.0267334 3.23827L6.53314 0.399261ZM6.62138 1.34855L1.93094 3.34722L9.06696 5.47575L13.1254 2.78561L6.62138 1.34855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.453949 11.069V3.4227L8.99887 5.97148V14.4674L0.453949 11.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.22409L9.45282 5.63318V15.1365L0 11.377V3.22409ZM0.907898 4.03182V10.7611L8.54492 13.7984V6.30979L0.907898 4.03182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.873 15.6007V7.10477L16 3.70639V11.3527L10.873 15.6007Z",
    fill: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenjie);
export default __webpack_public_path__ + "static/media/fenjie.e3a938f2df764e98236729577883e159.svg";
export { ForwardRef as ReactComponent };